import { MaterialIcon } from "@website/icons/material";
import { InputPropertiesType } from "@website/ui/datepicker/components/input/input.types";
import { numberConvert } from "@website/utils/number-convert";
import { useMemo } from "react";

export const useInput = (properties: InputPropertiesType) => {
  const {
    fromTitle,
    toTitle,
    value,
    setMode,
    calendarLocale,
    onOpenPopover,
    disabled,
    size = "default",
    noBorder,
    hideIcon,
    hasDropdownIcon
  } = properties;

  const MONTH_NAMES: Record<string, Array<string>> = {
    persian: [
      "فروردین",
      "اردیبهشت",
      "خرداد",
      "تیر",
      "مرداد",
      "شهریور",
      "مهر",
      "آبان",
      "آذر",
      "دی",
      "بهمن",
      "اسفند"
    ],
    gregorian: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  };

  const startTextFieldValue = useMemo(() => {
    if (value?.[0]) {
      const month = (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[
        value[0].month - 1
      ];
      const day = numberConvert(value[0].day, {
        numberOnly: true,
        locale: "fa"
      });

      return `${day} ${month}`;
    }
    return "";
  }, [value, calendarLocale]);

  const endTextFieldValue = useMemo(() => {
    if (value?.[1]) {
      const month = (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[
        value?.[1].month - 1
      ];
      const day = numberConvert(value?.[1].day, {
        numberOnly: true,
        locale: "fa"
      });

      return `${day} ${month}`;
    }
    return "";
  }, [calendarLocale, value]);

  return {
    rootProps: {
      tabIndex: 0
    },
    startTextFieldProperties: {
      "data-testid": "date_picker_start_input",
      label: value?.[0] ? fromTitle ?? "تاریخ شروع" : "",
      placeholder: value?.[0] ? "" : fromTitle ?? "تاریخ شروع",
      StartIcon: !hideIcon && <MaterialIcon name="date_range" variant="fill" />,
      EndIcon: hasDropdownIcon && (
        <MaterialIcon name="arrow_drop_down" variant="fill" />
      ),
      readOnly: true,
      value: startTextFieldValue,
      onClick: onOpenPopover,
      fullWidth: true,
      disabled,
      size,
      noBorder
    },
    endTextFieldProperties: {
      "data-testid": "date_picker_end_input",
      label: value?.[1] ? toTitle ?? "تاریخ پایان" : "",
      placeholder: value?.[1] ? "" : toTitle ?? "تاریخ پایان",
      readOnly: true,
      value: endTextFieldValue,
      onClick: onOpenPopover,
      fullWidth: true,
      EndIcon: hasDropdownIcon && (
        <MaterialIcon name="arrow_drop_down" variant="fill" />
      ),
      disabled,
      size,
      noBorder
    },
    endEnableButtonProperties: {
      role: "button",
      onClick: setMode?.bind(null, "start-end")
    },
    endEnableButtonText: toTitle ?? "تاریخ پایان"
  };
};
